import React, { Component ,createRef, Fragment} from 'react'
import axios from 'axios'
import { withRouter } from 'react-router'
import Toolbar from './Toolbar/Toolbar'
import { Tooltip} from "@material-ui/core"
import Dropdown from 'react-dropdown';
import { withStyles } from "@material-ui/core/styles"
import 'react-dropdown/style.css';
import TableOfContents from './TableOfContents/TableOfContents'
import _uniqueId from 'lodash/uniqueId';
import Directions from './AttachmentsDisplay/Directions'
import AttachmentRenderer from './AttachmentsDisplay/AttachmentRenderer'
import StepContent from './StepContent/StepContent'
import StepActionsToolBar from './StepActionsToolbar/StepActionsToolbar'
import ModelAnnotationContainter from "../Author/ModelAnnotation/ModelAnnotation"
import EditStepNameFieldContainer from './StepActionsToolbar/edit_step_name_field_container'
import PDFDisplay from "./WiPDFViewer/pdfViewer"
import PublicationPageModal from './PublicationPage/Modal'
import AttachmentsModal from './Attachments/Modal'
import AddInfoFormModal from './InfoPage/Modal'
import EditTagsModal from './Tags/Modal'
import { imageExtensions, audioExtensions, videoExtensions, documentExtensions} from "../../../Templates/data"
import { checkNotUndefindeNull, findExtension,isModel,replaceSpanWithTextInString,getRegexSelection } from "../../../Templates/functions"
import { circleExclamation, AnnotationModelIcon, tocToggleIcon, dotsIcon,closeStepAlertsIcon, countStepAlerts,openStepAlertsIcon,addAttachmentIcon  } from "../../../Templates/icons"
import { cloneDeep, isEmpty, isEqual, mapKeys } from 'lodash'
import {fetchWorkInstruction, deleteModelAnnotation, deleteHighlight, createHighlight } from '../../../../util/wi_util'
import { fileKey, fileName, fileUrl } from '../../../../util/file_url'
import { getFlatDataFromTree } from 'react-sortable-tree';
import StepAlerts from './InfoPage/StepAlerts'
import EditTitleForm from './Toolbar/edit_title_form_container'
import Highlighter from "react-highlight-words";
import temppdf from "./WiPDFViewer/assets/160.76-EG1.pdf"
import WebViewer from '@pdftron/webviewer'
import EmbeddedWISelect from '../Author/StepContent/EmbeddedWISelect';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPenToSquare } from '@fortawesome/free-regular-svg-icons'

// -------------------------------------------------------------- Tooltip Styles --------------------------------------------------------------//

export const LightTooltip = withStyles((theme) => ({
    tooltip: {
            backgroundColor: theme.palette.common.white,
            color: 'rgba(0, 0, 0, 0.87)',
            boxShadow: theme.shadows[1],
            fontSize: "1em",
        },
    }))(Tooltip);

// -------------------------------------------------------------- Component: WIAuthor --------------------------------------------------------------//

class WIAuthor extends Component {
    constructor(props) {
        super()
        this.state = {
            steps: props.workInstruction.steps || [],
            stepsDisplay:[],
            isSavable: true,
            title: "",
            WipGroup:[],
            tempPDF: temppdf,
            selectedStep:null,
            currentAttachments: [],
            attachmentIndex: 0,
            confirmationMessage: "",
            editingContent: false,
            editingPublicationPage: false,
            publicationPage: {},
            editingStepTitle: false,
            editingStepAlerts: false,
            editingtTags: false,
            showingAddInfoForm: false,
            showingAttachments: false,
            embeddedFile: undefined,
            toggleAnnotation: false,
            currentCameraPlacement:[],
            unityContextRef: null,
            selectedStepIsChild: false,
            editingTime:false,
            stepNodePath: [],
            showTOC:true,
            selectedStepDivID:"",
            pathList: [],
            searchString: "",
            stepDivsSearchText: null,
            textSelectedInEditorFlag:false,
            textSelectedInEditor:"",
            annotations:null,
            selectedAnnotation: null,
            existingAnnotationClicked: false,
            AnnotationMode: "view",
            DeleteAnnotationActive:false,
            Pointer:"circle",
            AnnotationArray: [],
            AnnotationCount:0,
            AnnotationText : "",
            modelsLoaded:false,
            AnnotationName: "",
            WebglAnnotationList: [],
            listSent:false,
            displayModelText:false,
            editorRef:null,
            toggleStepDropDown:false,
            isCurrentAttachmentTypeModel:false,
            modelIsLoaded:false,
            textSelectionRange:null,
            annotationHasBeenCreatedPre:false,
            currentStepAttachmentModel:false,
            displayArray:[],
            currentHighlightID: null,
            textToSearch:"",
            currentPDF: null,
            selectedText:"",
            annoList:[],
            viewerDiv: createRef(null),
            PDFAnnotations:null,
            pageNumber:1,
            currentlySelectedPDFAnnotationID: [],
            currentlySelectedPDFAnnotationAttachment:[],
            isRedraw:false,
            combinedTitle: [],
            addingPDFPageWILink: false,
            firstLoaded: false,
            isLibraryOpen: false,
        }
        this.handleModalOpen = this.handleModalOpen.bind(this)
    }
    
    componentDidMount = async () => {
        let intervalId = setInterval(this.runAutoSave,150000)//150000
        let stepDivParent = document.getElementById("step-Div-Parent")
        fetchWorkInstruction(this.props.wip_ID).then(
            res => {
                localStorage.removeItem('persist:wi_author')
                let wi = cloneDeep(res.data)
                let firstStep = wi.steps[0]
                //If the work instruction has info items, it will populate currentStepInfoItems with Objects containing keys of categories and a value of items in category. 
                let infoPage = typeof wi.info_page === "string" ? JSON.parse(wi.info_page) : wi.info_page
                
                let isModel = this.isAttachmentModel(firstStep,0)
                
                let currentStepInfoItems = this.buildInfoItems(infoPage, firstStep._id)
                this.setState({
                    intervalId,
                    currentStepInfoItems,
                    currentAttachments: this.SetAttachmentsBasedOnWipPDF(wi.isPDFViewer,firstStep, wi.PDFViewerHighlights),
                    infoPage: infoPage || {},
                    isReleased: wi.release,
                    previewImage: wi.preview_img || "default-wi-preview-img.jpg",
                    publicationPage: wi.publication_page || {},
                    selectedStep: firstStep,
                    steps: wi.steps,
                    path: firstStep ? [firstStep._id] : [],
                    tags: wi.tags,
                    WipGroup: wi.WipGroup,
                    title: wi.title,
                    isPDFViewer:wi.isPDFViewer,
                    pdfPath: wi.pdfPath,
                    PDFViewerHighlights:wi.PDFViewerHighlights,
                    originalTitle: wi.title,
                    require_info_checks: wi.require_info_checks,
                    workInstruction: wi,
                    stepDivsSearchText: typeof stepDivParent != "undefined" && stepDivParent != null ?  stepDivParent.innerText : "No Text",
                    selectedStepDivID: "div_step_" + firstStep._id,
                    currentStepAttachmentModel: isModel,
                }, () => {
                        this.setState({ loaded: true})
                        this.getSetWipPDF()
                        this.updateContentSpan()
                        this.createStepsDisplay()
                        this.createAnnotationArray()
                        
                })
        var pageListener = document.getElementById("wi-author-page")
        {pageListener ? pageListener.addEventListener("click", this.handleClicks) : console.log("unable to add listener to wi author")}
        this.setEventListener();
        this.setUnityCameraEventListener();
            }).catch((err)=>{
                alert("An error occured while trying to open this WI. Please contact an administrator for assisstance.")
                console.error(err)
            })
    }
// -------------------------------------------------------------- Component Lifecycle: componentDidUpdate --------------------------------------------------------------//

    componentDidUpdate(prevProps) {
        if(!isEqual(this.state.selectedStep, prevProps.selectedStep)) 
        {
            if(checkNotUndefindeNull(this.state.unityContextRef)) 
            {this.setUnityCameraEventListener();}

            if(this.state.selectedStep != null){
                let el = document.getElementById("div_step_" + this.state.selectedStep._id)
                if(el != null){
                    el.focus();
                }
            }
            this.updateContentSpan();
        }
    }  
// -------------------------------------------------------------- Component Lifecycle: componentWillUnmount --------------------------------------------------------------//

    componentWillUnmount = () => {
       this.unsetEventListener();
    }   
// -------------------------------------------------------------- Update content spans in the document --------------------------------------------------------------//

    updateContentSpan=()=>{

        let spans = document.getElementsByClassName("spansClick");
        let imgs = document.getElementsByClassName("closeImgWI");
        let ma = document.getElementsByClassName("closeImgMA");
        let closeout = <span style={{zIndex:"100",display:"inline-block",width:"10px",height:"10px"}} ><svg className="clickable"  xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
        <path  d="M7.5 0C3.3525 0 0 3.3525 0 7.5C0 11.6475 3.3525 15 7.5 15C11.6475 15 15 11.6475 15 7.5C15 3.3525 11.6475 0 7.5 0ZM7.5 13.5C4.1925 13.5 1.5 10.8075 1.5 7.5C1.5 4.1925 4.1925 1.5 7.5 1.5C10.8075 1.5 13.5 4.1925 13.5 7.5C13.5 10.8075 10.8075 13.5 7.5 13.5ZM10.1925 3.75L7.5 6.4425L4.8075 3.75L3.75 4.8075L6.4425 7.5L3.75 10.1925L4.8075 11.25L7.5 8.5575L10.1925 11.25L11.25 10.1925L8.5575 7.5L11.25 4.8075L10.1925 3.75Z" fill="#D7493F" />
      </svg></span>
        Array.from(spans).forEach((s)=>{
            if(s.classList.contains("NCL")){
               s.addEventListener("click",this.showAnnotation); 
               s.classList.remove("NCL");
               s.classList.add("CL")
            }
            if(s.classList.contains("WIL")){
                s.addEventListener("click",this.showWI); 
                s.classList.remove("WIL");
                s.classList.add("WL")
                
             }
        })
        Array.from(imgs).forEach((i)=>{
            i.addEventListener("click",this.deleteWI)
        })
        Array.from(ma).forEach((i)=>{
            i.addEventListener("click",this.deleteMA)
        })
    }
// -------------------------------------------------------------- Set Attachments Based on Work Instruction PDF --------------------------------------------------------------//

    SetAttachmentsBasedOnWipPDF=(isPDFViewer,firstStep,PDFViewerHighlights)=>{
        if(isPDFViewer)
        {
            return []
        }
        if(firstStep)
        {
         return firstStep.attachments
        }
        return []
    }
// -------------------------------------------------------------- Add wi link to WipGroup --------------------------------------------------------------//
    
    addWILink=(wi)=>{
        let WipGroup = cloneDeep(this.state.WipGroup)
        WipGroup.push(wi)
        this.setState({WipGroup},()=>{
            this.saveWorkInstruction();
        })
    } 
// -------------------------------------------------------------- remove wi link to WipGroup --------------------------------------------------------------//
    
    deleteWILink=(wi)=>{
        this.removeWILinkHighlight(wi.wiID)
        let WipGroup = cloneDeep(this.state.WipGroup)
        for(let w in WipGroup){
            if(WipGroup[w].wip_ID == wi.wiID){
                WipGroup[w].del = true
            }
        }
        //let WipGroup = Wg.filter(w=> w.wip_ID !== wi.wiID)   
        this.setState({WipGroup},()=>{
             this.saveWorkInstruction();
        })
    }
// -------------------------------------------------------------- remove annotation to WipGroup --------------------------------------------------------------//
    
    deleteAnnotation=(wi)=>{
        this.removeWILinkHighlight(wi.wiID)
        let Wg = cloneDeep(this.state.WipGroup)
        let WipGroup = Wg.filter(w=> w.wip_ID !== wi.wiID)   
        this.setState({WipGroup},()=>{
             this.saveWorkInstruction();
        })
    }
// -------------------------------------------------------------- will remoce the WI highlioght from the text --------------------------------------------------------------//
    
    removeWILinkHighlight=(wi)=>{
        let content = this.state.selectedStep.content
        let regExp = new RegExp('\\&lt;WI,(.*?),(.*?),(.*?).&gt;','g')
        let matchesAll = [...content.matchAll(regExp)]
        if(null != matchesAll && matchesAll.length > 0){
            for(let i = 0; i < matchesAll.length; i++){
                if(matchesAll[i][2] === wi){
                    let newContent = content.replace(matchesAll[i][0],"")
                    let selectedStep = this.state.selectedStep
                    if (selectedStep) {
                        selectedStep.content = newContent
                        let steps = this.updateStep(selectedStep)
                        this.updateSteps(steps, selectedStep);
                        this.createStepsDisplay();      
                    }
                }
            }
        }
    }

    handleClicks =(event) => {
        var page = document.getElementById("wi-author-page")
        var timeEsti = document.getElementById("edit-step-estimation-form")
        if(page && timeEsti){
            if(!event.path.find(({id})=> id === "edit-step-estimation-form")) {
                this.toggleEditingTime(false)
            }
        }
    }

    checkIfAttachmentHasAnnotationArray =() => {
        let selectedStepClone = cloneDeep(this.state.selectedStep)
        if(checkNotUndefindeNull(selectedStepClone)){
            let attachments = selectedStepClone.attachments  
            const currentAttachment = attachments[this.state.attachmentIndex || 0]  
            
            if(attachments.length > 0 && typeof currentAttachment.annotations != "undefined" && currentAttachment.annotations != null && currentAttachment.annotations.length > 0){
                console.log(typeof currentAttachment.annotations)
                currentAttachment.annotations = [];
                attachments[this.state.attachmentIndex || 0] = currentAttachment
                selectedStepClone.attachments = attachments
                let steps = this.updateStep(selectedStepClone)
                this.updateSteps(steps, selectedStepClone);
            }
        }
    }
// -------------------------------------------------------------- Set Unity Camera Event Listener --------------------------------------------------------------//

    setUnityCameraEventListener =() =>{
        if (this.state.unityContextRef != null){
            this.state.unityContextRef.on("modelsLoaded", () => {
                this.setState({modelsLoaded: true});
                this.sendlist()
            })
            this.state.unityContextRef.on("storeCameraData", (cameraData) => {            
                let pasredCameraData = JSON.parse(cameraData);   
                let SelectedAnnotationClone = cloneDeep(this.state.selectedAnnotation);
                if(SelectedAnnotationClone != null){
                    let state = JSON.parse(SelectedAnnotationClone.state) 
                    SelectedAnnotationClone.camera_position = this.convertCameraData(pasredCameraData.position);
                    SelectedAnnotationClone.camera_rotation = this.convertCameraData(pasredCameraData.rotation);//orgCameraData
                    state.orgCameraData = cameraData
                    SelectedAnnotationClone.state = JSON.stringify(state)
                    this.setState({selectedAnnotation : SelectedAnnotationClone});
                }        
            });
            this.state.unityContextRef.on("storeClickedAnnotation", (AnnotationData) => {
            })
            this.state.unityContextRef.on("storeCreatedAnnotation", (AnnotationData) => {
                this.addAnnotation(AnnotationData); 
            })
            this.state.unityContextRef.on("storeDeletedAnnotation", (AnnotationData) => {
                let data = JSON.parse(AnnotationData)
                this.deleteAnnotationFromWebgl(data.id)   
            })
        }
    }
// -------------------------------------------------------------- Stores a created annotation. --------------------------------------------------------------//
    
    storeCreatedAnnotation=()=>{
    }
// -------------------------------------------------------------- Converts camera data into a string representation. --------------------------------------------------------------//

    convertCameraData =(data) =>{
        let cameraDataString = data.x.toString() + ", " + data.y.toString() + ", " + data.z.toString()
        return cameraDataString
    }
// -------------------------------------------------------------- Converts rotation data into a string representation. --------------------------------------------------------------//

    convertRotationData =(data) =>{
        let cameraDataString = data.w.toString() + ", " + data.x.toString() + ", " + data.y.toString() + ", " + data.z.toString()
        return cameraDataString
    }
// -------------------------------------------------------------- Unsets an event listener and updates the element's position if needed. --------------------------------------------------------------//

    unsetEventListener =() =>{
        let display = document.getElementById("webGL-window")
        {display? display.removeEventListener("click",this.updateCamerandMousePosition): console.log("Unable to unset click listener for webgl")}
        {display? display.style.removeProperty("position"): console.log("Unable to remove positon to absolute for webgl")}
        if (this.state.unityContextRef != null){
        }
    }
// -------------------------------------------------------------- Sets an event listener and updates the element's position if needed. --------------------------------------------------------------//

    setEventListener =() =>{
        let display = document.getElementById("webGL-window")
        {display? display.addEventListener("click",this.updateCamerandMousePosition): console.log("Unable to set click listener for webgl")}
        {display? display.style.setProperty("position","absolute"): console.log("Unable to set positon to absolute for webgl")}  
    }
// -------------------------------------------------------------- Handles a text selection event and logs a message. --------------------------------------------------------------//

    textSelected=(e)=>{
    }
// -------------------------------------------------------------- Sets the selected annotation, updates the state, and sends data to the model viewer. --------------------------------------------------------------//

    setSelectedAnnotation = (annotation ,id) =>{
        this.removeSelectedAnnotationClass();
        let newSelectedDiv = document.getElementById(id)
        if(typeof newSelectedDiv != "undefined" && newSelectedDiv != null){
            newSelectedDiv.classList.add("selectedAnnotation")
        }
        let state = JSON.parse(annotation.state)
        this.setState(
            {AnnotationMode : "view", 
            selectedAnnotation: annotation, 
            DeleteAnnotationActive: true, 
            Pointer: annotation.pointer , 
            AnnotationText: annotation.message || "", AnnotationName: state.name,
            existingAnnotationClicked: true
            })
            this.sendAnnotationToWebgl(annotation.Anno_id)
            this.clickOnAnnotation(annotation.Anno_id);
    }
// -------------------------------------------------------------- Sends an annotation to the WebGL viewer. --------------------------------------------------------------//

    sendAnnotationToWebgl=(id)=>{
        if(checkNotUndefindeNull(this.state.unityContextRef)){
            this.state.unityContextRef.send("Manager","ShowAnnotation",(id))
            this.state.unityContextRef.send("Manager","LookAtAnnotation",(id))
        }
    }
// -------------------------------------------------------------- Creates a new annotation. --------------------------------------------------------------//

    createAnnotation =(highLightedText)=>{
        if(this.state.isLibraryOpen){
            return;
        }
        let randString = this.makeid(15)
        let id = _uniqueId(`${randString}-`)
        let name = highLightedText
        let displayWidth = document.getElementById("webGL-window").clientWidth;
        let displayHeight = document.getElementById("webGL-window").clientHeight;
        let NewAnnotation ={
            Anno_id : id,
            background_color: "#ffffff",
            state: JSON.stringify({name:name,canvasWidth: displayWidth, canvasHeight:displayHeight, orgCameraData:{} }),
            message: highLightedText? highLightedText : "",
            camera_position: "",
            camera_rotation: "", 
            x: 0,
            y: 0,
            pointer: "circle"
        }
        this.removeSelectedAnnotationClass();
        this.setState({AnnotationMode : "new",selectedAnnotation: NewAnnotation, Pointer: "circle", AnnotationText:"", AnnotationName: name,existingAnnotationClicked: false});
    
    }
// -------------------------------------------------------------- Adds an annotation. --------------------------------------------------------------//

    addAnnotation = (data) => {
        if(this.state.isLibraryOpen){
            return;
        }
        let webGLWindow = document.getElementById("webGL-window");
        let anno_array = cloneDeep(this.state.AnnotationArray)
        let name = this.state.textSelectedInEditor
        let displayWidth = webGLWindow.clientWidth;
        let displayHeight = webGLWindow.clientHeight;
        let parsedData = JSON.parse(data)
        let newAnnotation =  {
             wipID:this.state.workInstruction._id,
             StepID: !this.state.workInstruction.isPDFViewer ? this.state.selectedStep._id : null,
             HighlightID:this.state.workInstruction.isPDFViewer ? this.state.currentlySelectedPDFAnnotationID : null,
             AttachmentID:this.state.currentAttachments[this.state.attachmentIndex]._id,
             Anno_id : parsedData.id,
             background_color: "#ffffff",
             state: JSON.stringify({name:name,canvasWidth: displayWidth, positon:this.convertCameraData(parsedData.position), canvasHeight:displayHeight, orgCameraData:data, scale:parsedData.scale }),
             message: this.state.textSelectedInEditor,
             camera_position: this.convertCameraData(parsedData.cameraPosition),
             camera_rotation: this.convertRotationData(parsedData.cameraRotation), 
             x: 0,
             y: 0,
             pointer: "circle"}
        this.setState({AnnotationMode : "new",
        selectedAnnotation: newAnnotation, 
        Pointer: "circle", 
        AnnotationText:parsedData.text, 
        AnnotationName: name,
        existingAnnotationClicked: false, 
        annotationHasBeenCreatedPre:true});
    }
// -------------------------------------------------------------- Handles clicking on an annotation. --------------------------------------------------------------//

    clickOnAnnotation =(id) =>{
        if(this.state.isLibraryOpen){
            return;
        }
        if(!this.state.listSent){
            this.sendlist();
            this.setState({listSent:true})
            setTimeout(()=>{
                if(checkNotUndefindeNull(this.state.unityContextRef)){
                    this.state.unityContextRef.send("Manager","ShowAnnotation",id)
                    this.state.unityContextRef.send("Manager","LookAtAnnotation",id)
                }
            },100)
        }
        else{
            if(checkNotUndefindeNull(this.state.unityContextRef)){
                this.state.unityContextRef.send("Manager","ShowAnnotation",id)
                this.state.unityContextRef.send("Manager","LookAtAnnotation",id)
            }
        }      
    }
// -------------------------------------------------------------- Saves a new or edited annotation. --------------------------------------------------------------//

    saveNewAnnotation=()=>{
        if(this.state.isLibraryOpen){
            return;
        }
        let selectedStepClone = cloneDeep(this.state.selectedStep)
        if(this.state.existingAnnotationClicked){
            let annotations = selectedStepClone.attachments[this.state.attachmentIndex].annotations
            annotations.forEach(annotation => {
                if (annotation.Anno_id == this.state.selectedAnnotation.Anno_id){
                   let str =  JSON.parse(annotation.state)
                   str.name = this.state.AnnotationName
                   annotation.state = JSON.stringify(str)
                   annotation.message = this.state.AnnotationText
                }
            })
            selectedStepClone.attachments[this.state.attachmentIndex].annotations = annotations
        }else{  
        selectedStepClone.attachments[this.state.attachmentIndex].annotations.push(this.state.selectedAnnotation)  
        }
        let steps = this.updateStep(selectedStepClone)
        if(null != this.state.unityContextRef){
        }
        this.updateSteps(steps, selectedStepClone); 
        this.setState({AnnotationMode : "view" , textSelectedInEditorFlag:false, textSelectedInEditor:"",annotationHasBeenCreatedPre:false,addedAnnotation:false})     
        this.createAnnotationArray();
    }
// -------------------------------------------------------------- Deletes an annotation. --------------------------------------------------------------//

    deleteAnnotationCloseImg = (annotationID,index) =>{
             let selectedStepClone = cloneDeep(this.state.selectedStep)
             let annotations = selectedStepClone.attachments[index].annotations
             let filteredAnnotations =  annotations.filter(annotation => annotation.Anno_id !== annotationID)
             let annotationToDelete =  annotations.filter(annotation => annotation.Anno_id == annotationID)  
                if(checkNotUndefindeNull(this.state.unityContextRef)){     
                    this.state.unityContextRef.send("Manager","SetRemoveAnnotation", annotationID)
                } 
                selectedStepClone.attachments[index].annotations = filteredAnnotations 
                let stepContent = selectedStepClone.content
                let matches = getRegexSelection(selectedStepClone.content,new RegExp('\\&lt;Annotation,(.*?),(.*?),(.*?).&gt;','g'))  
                if(null != matches && matches.length > 0){
                    for(let i = 0; i < matches.length; i++){              
                            if(matches[i][1] === annotationID){
                                let replacementText = matches[i][3]
                                stepContent = stepContent.replace(matches[i][0],replacementText)
                                selectedStepClone.content = stepContent
                                break;
                            }  
                    }                      
                }        
                let steps = this.updateStep(selectedStepClone)
                this.updateSteps(steps, selectedStepClone, false,false,this.props.selectedStepIsChild, false); 
                this.setState({AnnotationMode : "view", AnnotationText: ""},()=>{
                    this.createStepsDisplay();
                })
    }

    deleteAnnotation = () =>{
             let selectedStepClone = cloneDeep(this.state.selectedStep)
             let annotations = selectedStepClone.attachments[this.state.attachmentIndex].annotations
             let filteredAnnotations =  annotations.filter(annotation => annotation.Anno_id !== this.state.selectedAnnotation.Anno_id)
             if(checkNotUndefindeNull(this.state.unityContextRef)){
                this.state.unityContextRef.send("Manager","SetRemoveAnnotation", this.state.selectedAnnotation.Anno_id)
             }   
             selectedStepClone.attachments[this.state.attachmentIndex].annotations = filteredAnnotations
             let steps = this.updateStep(selectedStepClone)
             this.updateSteps(steps, selectedStepClone, false,false,this.props.selectedStepIsChild, false); 
             this.setState({AnnotationMode : "view", AnnotationText: ""})
    }
// -------------------------------------------------------------- Deletes an annotation from WebGL viewer. --------------------------------------------------------------//

    deleteAnnotationFromWebgl = (annotationID) =>{
             let selectedStepClone = cloneDeep(this.state.selectedStep)
             let annotations = selectedStepClone.attachments[this.state.attachmentIndex].annotations
             let filteredAnnotations =  annotations.filter(annotation => annotation.Anno_id !== annotationID)
             selectedStepClone.attachments[this.state.attachmentIndex].annotations = filteredAnnotations           
             let steps = this.updateStep(selectedStepClone)
             this.updateSteps(steps, selectedStepClone); 
             this.setState({AnnotationMode : "view", AnnotationText: ""})
    }
// -------------------------------------------------------------- Sends a list of annotations to the WebGL viewer. --------------------------------------------------------------//

    sendlist =() =>{
        if(checkNotUndefindeNull(this.state.unityContextRef)){
            this.state.unityContextRef.send("Manager","SetAnnotations",JSON.stringify({annotationDatas:this.state.WebglAnnotationList}))
        }
    }
// -------------------------------------------------------------- Updates the selected step. --------------------------------------------------------------//

    updateSelectedStep=(step)=>{
        this.setState({selectStep:step})
    }
// -------------------------------------------------------------- Passer function that sets title in Children Components --------------------------------------------------------------//

    setTitle = (newTitle) => {
        this.setState({ title: newTitle });
    }
// -------------------------------------------------------------- Creates an array of annotations for the WebGL viewer. --------------------------------------------------------------//

    createAnnotationArray =() =>{
        let WebglList = []
        if(this.state.selectedStep != null){
            let attachments = this.state.selectedStep.attachments                
            const currentAttachment = attachments[this.state.attachmentIndex || 0]       
            if (true){
                if(checkNotUndefindeNull(currentAttachment) && checkNotUndefindeNull(currentAttachment.annotations)){
                        currentAttachment.annotations.forEach(annotation => {          
                        let state = ""
                        if(annotation.state){
                            state = JSON.parse(annotation.state)
                        }else{
                            state = {name:"Annotation"}
                        }
                        WebglList.push(JSON.parse(state.orgCameraData))                                  
                        })
                    }              
            }       
        }
        this.setState({ WebglAnnotationList : WebglList})
    }
// -------------------------------------------------------------- Builds a dictionary of info items for the given step. --------------------------------------------------------------//

    buildInfoItems = (infoPage, stepId) => {
        let currentStepInfoItems = {}
        if (!isEmpty(infoPage)) {
            for (const [infoItem, infoObject] of Object.entries(infoPage)) {
                if (infoObject.steps.includes(stepId)) {
                    if (!currentStepInfoItems[infoObject.category]) {
                        currentStepInfoItems[infoObject.category] = []
                    }
                    currentStepInfoItems[infoObject.category].push(infoItem)
                }
            }
        }
        return currentStepInfoItems
    }
// -------------------------------------------------------------- Closes the confirmation message. --------------------------------------------------------------//

    closeConfirmation = (e) => {
        this.setState({ confirmationMessage: "" });
    }
// -------------------------------------------------------------- Handles opening an embedded attachment. --------------------------------------------------------------//

    openEmbeddedAttachment = (e) => {
        e.preventDefault();
        e.stopPropagation();
        let fileName = e.target.innerText
        this.setState({ embeddedFile: fileName })
    }
// -------------------------------------------------------------- Initiates preview of the work instruction. --------------------------------------------------------------//

    previewWorkInstruction = () => {
        this.saveWorkInstruction(this.props.history.push(`/dashboard/work instructions/preview/${this.state.workInstruction._id}`))
    }

    handleModalOpen = () => {
        this.setState({isLibraryOpen: true})
    }

    backToWIList=()=>{
        let url = "/dashboard/work instructions"
        this.props.history.push(url)
    }
// -------------------------------------------------------------- Renders different modals based on component state. --------------------------------------------------------------//

    renderModal = () => {
        if (this.state.embeddedFile) {
            let embeddedFile = this.state.embeddedFile
            let files = this.state.currentAttachments.filter(attachment => attachment.path === embeddedFile)
            let fileExtension = findExtension(embeddedFile)
            let fileExtensions
            if (audioExtensions.includes(fileExtension)) {
                fileExtensions = audioExtensions
            } else if (videoExtensions.includes(fileExtension)) {
                fileExtensions = videoExtensions
            } else if (imageExtensions.includes(fileExtension)) {
                fileExtensions = imageExtensions
            } else {
                fileExtensions = documentExtensions[0]
            }
               
            let isImageType = isEqual(fileExtensions, imageExtensions)
            return <AttachmentsModal 
                callingComponent={"Work Instruction Author File Viewer"}
                isLibraryOpen={this.state.isLibraryOpen}
                handleModalOpen={this.handleModalOpen}
                workInstructionId={this.props.match.params.WIID}
                modalTitle={isImageType ? "Images" : "File List"}
                closeModal={() => {
                    this.setState({ embeddedFile: "", isLibraryOpen: false })}
                }
                fileTypes={fileExtensions}
                files={files}
                selectedStep={this.state.selectedStep}
                updateStep={this.updateStep}
                updateSteps={this.updateSteps}
            />
        } else if (this.state.showingAddInfoForm) {
            return <AddInfoFormModal
                modalTitle={<div className="flex-centered" style={{marginLeft: '1em'}}>
                    {circleExclamation}
                    <p style={{marginLeft: ".5em"}}>All Alerts</p>
                    </div>}
                callingComponent={"Work Instruction Author Add Info"}
                closeModal={this.toggleAllAlertsPage}
                updateInfoPage={this.updateInfoPage}
                infoPage={this.state.infoPage}
                steps={this.state.steps}
                toggleGlobalItem={this.toggleGlobalItem}
                addCategoryToInfoItem={this.saddCategoryToInfoItem}
                editItemName={this.editItemName}
                addItemToInfoPage={this.addItemToInfoPage}
                runInfoPageCleanUp={this.runInfoPageCleanUp}
                addItemToStep={this.addItemToStep} />
        } else if (this.state.showingAttachments) {
            let attachmentForLib = this.setCurrentAttachmentsforLibrary()
            return <AttachmentsModal
                modalTitle={"Attachments Library"}
                callingComponent={"Work Instruction Author Attachments Library"}
                closeModal={() => {
                    this.toggleAttachments()
                    this.setState({ embeddedFile: "", isLibraryOpen: false })}
                }
                WIPID = {this.state.workInstruction._id}
                HighlightID ={this.state.currentHighlightID}
                currentAttachments={attachmentForLib}//{this.state.selectedStep ? mapKeys(this.state.selectedStep.attachments, "_id") : {}}
                previewAttachment={this.previewAttachment}
                selectedStep={this.state.selectedStep}
                isPDFViewer={this.state.isPDFViewer}
                isLibraryOpen={this.state.isLibraryOpen}
                handleModalOpen={this.handleModalOpen}
                currentlySelectedPDFAnnotationID={this.state.currentlySelectedPDFAnnotationID}
                currentlySelectedPDFAnnotationAttachment={this.state.currentlySelectedPDFAnnotationAttachment}
                saveNewPDFHighLightAttachments={this.saveNewPDFHighLightAttachments}
                steps={this.state.steps}
                updateStep={this.updateStep}
                updateSteps={this.updateSteps}

            />
        } else if (this.state.editingPublicationPage) {
            return <PublicationPageModal
                backToWIList = {this.backToWIList}
                previewImage={this.state.previewImage}
                setTitle={this.setTitle}
                setPreviewImage={(path) => this.setState({ previewImage: path, isSavable: true })}
                setPreviewImages={(paths) => this.setState({ previewImages: paths, isSavable: true })}
                setInfoChecksRequirement={(bool) => this.setState({ require_info_checks: bool, isSavable: true })}
                infoChecksRequirement={this.state.require_info_checks}
                steps={this.state.steps}
                // PUBLICATION PAGE IS PAYLOAD FROM PublicationPage component
                updatePublicationPage={(publicationPage) => this.setState({ publicationPage, isSavable: true })}
                publicationPage={this.state.publicationPage}
                toggleRelease={this.toggleRelease}
                workInstruction={this.state.workInstruction}
                title={this.state.title}
                modalTitle={"Publication Page"}
                callingComponent={"Work Instruction Author Publication Page"}
                closeModal={this.togglePublicationPage}
            />
        } else if (this.state.editingTags) {
            return <EditTagsModal
                workInstructionId={this.state.workInstruction._id}
                currentWorkInstructionTags={this.state.tags}
                modalTitle={"Edit Tags Form"}
                callingComponent={"Work Instruction Author Tags Edit"}
                closeModal={this.toggleEditTags}
                updateTags={(tags) => this.setState({ isSavable: true, editingTags: false, tags })} />
        } 
     else if (this.state.addingPDFPageWILink && this.state.isPDFViewer ){
        return <EmbeddedWISelect
                    attachWIButton={this.addNewWILinkAnnotation}
                    SetToClose={()=>this.setWILinkModal(false)}
                    openNewTab={this.openNewTab}
               >
               </EmbeddedWISelect>
    }
        else {
            return
        }
    }
// -------------------------------------------------------------- Determines the current attachments for the library view. --------------------------------------------------------------//

    setCurrentAttachmentsforLibrary=()=>{
        if(this.state.isPDFViewer){
            if(this.state.currentAttachments){
              return  mapKeys(this.state.currentAttachments, "_id") 
            } 
        }
        else{
            if(this.state.selectedStep){
                return  mapKeys(this.state.selectedStep.attachments, "_id") 
            }
        }
        return {} 
    }
// -------------------------------------------------------------- Checks if two quads for annotations are the same. --------------------------------------------------------------//

    isHighlightTheSame=(quad1,quad2)=>{ 
        if (quad1.x1 == quad2.x1 && quad1.x2 == quad2.x2 && quad1.x3 == quad2.x3 && quad1.x4 == quad2.x4 &&
            quad1.y1 == quad2.y1 && quad1.y2 == quad2.y2 && quad1.y3 == quad2.y3 && quad1.y4 == quad2.y4){
                return true;
            }
            return false;
    }
// -------------------------------------------------------------- Removes an annotation from the WebGL viewer. --------------------------------------------------------------//

    removeAnnotationFromScreen=(annotationID)=>{
        if(checkNotUndefindeNull(this.state.unityContextRef)){
            this.state.unityContextRef.send("Manager","SetRemoveAnnotation",annotationID)
        }
    }
// -------------------------------------------------------------- Saves new PDF highlight attachments. --------------------------------------------------------------//

    saveNewPDFHighLightAttachments=(attachments)=>{
     let clone =  cloneDeep(this.state.annoList ) 
     clone.forEach(anno=>{
         if(this.isHighlightTheSame(anno.quads[0],this.state.currentlySelectedPDFAnnotationID))
         {
             anno.attachments = attachments
         }
     })
     this.setState({annoList:clone,currentAttachments:attachments,attachmentIndex:0, attcurrentlySelectedPDFAnnotationAttachment:attachments,isSavable:true})
    }
// -------------------------------------------------------------- Initiates an auto-save of the work instruction. --------------------------------------------------------------//

    runAutoSave = () => this.state.isSavable ? this.saveWorkInstruction() : null;
// -------------------------------------------------------------- Recursively finds and replaces info in the object based on the 'content' key. --------------------------------------------------------------//

    findAllByKey=(target)=> {
        if (typeof target === 'object') {
            for (let key in target) {
                if (typeof target[key] === 'object') {
                    this.findAllByKey(target[key]);
                } else {
                    if (key === 'content') {
                        target[key] = replaceSpanWithTextInString(target[key])                       
                    }
                }
            }
        }
        return target
    }
// -------------------------------------------------------------- Checks step content for temporary highlights. --------------------------------------------------------------//

    checkStepContentForTempHighlight=(steps)=>{
        let spans = document.getElementsByClassName("TempHighlight")
        if(spans.length > 0){
            let test =  this.findAllByKey(steps)
        }
        return steps 
    }
// -------------------------------------------------------------- Saves work instruction data, handles release and updates. --------------------------------------------------------------//

    saveWorkInstruction = (togglingRelease, nextReleaseState, previewCB) => {
        let workInstruction = cloneDeep(this.state.workInstruction)
        let checkedSteps  = cloneDeep(this.state.steps)
        checkedSteps = this.checkStepContentForTempHighlight(checkedSteps)
        workInstruction.release = false
        workInstruction.isAssignable = false
        workInstruction.title = this.state.title
        workInstruction.steps = this.updateStepOrder(checkedSteps)
        workInstruction.WipGroup = this.state.WipGroup
        workInstruction.PDFViewerHighlights = this.state.annoList
        workInstruction.preview_img = this.state.previewImage
        workInstruction.previewImages = this.state.previewImages
        workInstruction.workStatus = "Not Started"
        workInstruction.info_page = JSON.stringify(this.state.infoPage)
        workInstruction.tags = this.state.tags
        workInstruction.publication_page = this.state.publicationPage
        workInstruction.require_info_checks = this.state.require_info_checks
        if (togglingRelease) {
            workInstruction.release = nextReleaseState
            this.props.updateWorkInstruction(workInstruction).then((data)=>{
                if (nextReleaseState !== undefined) {
                                
                                this.setState({
                                    confirmationMessage: 
                                        nextReleaseState ? 
                                            `Your Work Instruction Has Been Released. It may take a few minutes before it appears in the Assignments Page.` 
                                                : 
                                            'Your Work Instruction Has Been Unreleased.',
                                    isReleased: nextReleaseState,
                                    isSavable: false
                                },()=> setTimeout(this.backToWIList(),1000))
                            }
                            setTimeout(this.closeConfirmation, 10000)

            }).catch((err)=>{
                console.log(err)
            })
            
        } else {
            this.props.updateWorkInstruction(workInstruction).then((data)=>{
                this.setState({ 
                                confirmationMessage: "Your Work Instruction has been saved.", 
                                isReleased: false, 
                                isSavable: false
                            }, previewCB ? previewCB : () => setTimeout(this.closeConfirmation, 10000)
                            )

            }).catch((err)=>{
                console.log(err)
            })
            
        }
    }
// -------------------------------------------------------------- Handles the selection of a step. --------------------------------------------------------------//
 
    updateStepOrder=(treeData)=>{
        const stepLoop=(steps)=>{
            for(let i =0; i<steps.length;i++){
                    steps[i].order = i + 1;
                if(steps[i].children.length > 0){
                    stepLoop(steps[i].children)
                }
            }
        }

        for(let i =0; i<treeData.length;i++){
            treeData[i].order = i + 1;
            if(treeData[i].children.length > 0){
                stepLoop(treeData[i].children)
            }
        }

        return treeData
    }
// -------------------------------------------------------------- Handles the selection of a step. --------------------------------------------------------------//

    selectStep = (selectedStep, path,stepClick) => {
        if (null != selectedStep && path != this.state.path && selectedStep._id != this.state.selectedStep){
        let currentStepInfoItems = this.buildInfoItems(this.state.infoPage, selectedStep._id)
        let currentAttachments = selectedStep.attachments || []
        if(this.state.isPDFViewer){
            currentAttachments = []
        }

        let stepIsChild = false
        if(!Array.isArray(path)){
            path=[path]
        }

        if(path.length > 1){stepIsChild = true}
        
        let stepID = "div_step_" + selectedStep._id
        this.checkIfAttachmentHasAnnotationArray();
        let isModel = this.isAttachmentModel(selectedStep,0)
        
        this.setState({
            selectedStep,
            path,
            currentAttachments,
            editingContent: false,
            editingStepAlerts: false,
            toggleAnnotation: false,
            currentStepInfoItems,
            attachmentIndex: 0,
            selectedStepIsChild: stepIsChild,
            selectedStepDivID:stepID,
            currentStepAttachmentModel: isModel,
            textSelectedInEditor:"",
            textSelectedInEditorFlag:false,
            modelsLoaded:false
        },()=>{
            this.updateContentSpan()
            this.createStepsDisplay()
            this.createAnnotationArray()
            if(typeof stepClick != "undefined" && stepClick)
            {
                let node = document.getElementsByClassName("selected-container")
                if(node.length > 0){
                  node[0].click();
                }
            }
        })
                           
        }
    }
// -------------------------------------------------------------- Initiates a continuous loop to navigate after a step deletion. --------------------------------------------------------------//

    stepDeleted = () =>{
        let intervalId = setInterval(()=>{
            let id = this.state.path[this.state.path.length - 1]
            let step = document.getElementById("div_step_" + id)
            if(step)
                step.click()
        },100)
    }
// -------------------------------------------------------------- Stores color information for an attachment. --------------------------------------------------------------//

    storeColor = (color) => {
        let selectedStep = this.state.selectedStep
        let currentAttachments = this.state.currentAttachments
        currentAttachments[this.state.attachmentIndex].background_color = color
        selectedStep.attachments = currentAttachments
        let steps = this.updateStep(selectedStep)
        this.updateSteps(steps, selectedStep)
    }
// -------------------------------------------------------------- Stores camera data for an attachment. --------------------------------------------------------------//

    storeCameraData = (cameraData) => {
        let selectedStep = this.state.selectedStep
        let currentAttachments = this.state.currentAttachments
        currentAttachments[this.state.attachmentIndex].cameraData = cameraData
        selectedStep.attachments = currentAttachments
        let steps = this.updateStep(selectedStep)
        this.updateSteps(steps, selectedStep);
        this.setState({currentCameraPlacement:cameraData})
    }
// -------------------------------------------------------------- Handles the submission of edited title data. --------------------------------------------------------------//

    submitTitleEdit = (title) => {
        this.setState({
            editingTitle: false,
            title,
        })
    }
// -------------------------------------------------------------- Toggles the display of the "Add Info" form. --------------------------------------------------------------//

    toggleAllAlertsPage = (e) => {
        this.setState(prevState => ({ showingAddInfoForm: !prevState.showingAddInfoForm }));
    }
// -------------------------------------------------------------- Toggles the display of attachments. --------------------------------------------------------------//

    toggleAttachments = (e) => {
        this.setState(prevState => ({ showingAttachments: !prevState.showingAttachments }),()=>{
            if(this.state.showingAttachments == false){
                let node = document.getElementsByClassName("selected-container")
                if(node.length > 0){
                  node[0].click();
                }
            }
        });
    }
// -------------------------------------------------------------- Toggles the editing state for tags. --------------------------------------------------------------//

    toggleEditTags = (e) => {
        return this.setState(prevState => ({ editingTags: !prevState.editingTags }));
    }
// -------------------------------------------------------------- Toggles the publication page with or without release. --------------------------------------------------------------//

    togglePublicationPage = (e, withRelease) => {
        return withRelease === true ?
            this.setState(prevState => ({ editingPublicationPage: !prevState.editingPublicationPage, confirmationMessage: "Your Work Instruction is being finalized" }), () => setTimeout(this.toggleRelease, 4000)): 
            this.setState(prevState => ({ editingPublicationPage: !prevState.editingPublicationPage }))
    }
// -------------------------------------------------------------- Toggles the selected text in the editor. --------------------------------------------------------------//

    toggleTextSelectedInEditor =(selectedText,range)=>{
        let flag = false;
        if(checkNotUndefindeNull(selectedText) && selectedText != ""){flag = true}
        this.setState ({ textSelectedInEditorFlag: flag ,textSelectedInEditor: selectedText,textSelectionRange: range,annotationHasBeenCreatedPre:flag});
    }
// -------------------------------------------------------------- Toggles the work instruction release state. --------------------------------------------------------------//

    toggleRelease = () => {
        return this.saveWorkInstruction(true, !this.state.isReleased);
    }
// -------------------------------------------------------------- Toggles the editing time state. --------------------------------------------------------------//

    toggleEditingTime = (editingTime) =>{
        this.setState({editingTime:editingTime})
    }
// -------------------------------------------------------------- Updates the info page. --------------------------------------------------------------//

    updateInfoPage = (infoPage) => {
        let step = this.state.selectedStep
        step.infoPage = infoPage
        let steps = this.updateStep(step)
        this.updateSteps(steps,step)
        this.setState({ infoPage, isSavable: true },()=>{
            this.saveWorkInstruction();           
        });
    }

    getInfoPage=()=>{
        return this.state.infoPage
    }
// -------------------------------------------------------------- Renders an icon for step alerts. --------------------------------------------------------------//

    renderStepAlertsIcon = () => {
        let infoPage = this.state.infoPage && !isEmpty(this.state.infoPage) ? this.state.infoPage : null
        let numStepAlerts = 0
        let infoList = []
        if (infoPage) {
            let infoItems = Object.keys(infoPage)
            let currentItems = {}
            infoItems.forEach(item => {
                let currentStep = this.state.selectedStep;
                let currentStepId = currentStep ? currentStep._id : 0
                let testItem = infoPage[item];
                testItem.steps.forEach(stepId => {
                    let isGlobal = testItem.global
                    let isIncluded = stepId === currentStepId 
                    if (isGlobal || isIncluded) {                        
                        if (currentItems[item]) {
                            currentItems[item].push(currentStep)
                        } else {
                            currentItems[item] = [currentStep]
                        }
                    }
                })
            })

            numStepAlerts = Object.keys(currentItems).length
            infoList = Object.keys(currentItems).map(item => (<li key={`${item}`}> - {item}</li>))
            
        }
        let tooltipText = numStepAlerts ? 
                <ul>
                    <p className="underline">Current Alerts</p>
                    {infoList}
                </ul>
            : "Edit Step Alerts";
            return this.props.editingStepAlerts ? 
                closeStepAlertsIcon(numStepAlerts, this.state.toggleStepAlerts, tooltipText,false): 
                openStepAlertsIcon(numStepAlerts, this.state.toggleStepAlerts, tooltipText,false)
    }
// -------------------------------------------------------------- Updates the toggleAnnotation state. --------------------------------------------------------------//

    updateToggleAnnotation = (toggleAnnotation) => {
        this.setState({toggleAnnotation: toggleAnnotation, editingStepAlerts: false});
    }
// -------------------------------------------------------------- Updates the editingStepAlerts state. --------------------------------------------------------------//

    updateEditingStepAlerts = (e) =>{
        e.stopPropagation()
        let toggleStepAlert = this.state.editingStepAlerts
        this.setState ({editingStepAlerts: !toggleStepAlert,toggleAnnotation: false,editingContent:false },()=>this.createStepsDisplay())
    }
// -------------------------------------------------------------- Updates the toggleStepContent state. --------------------------------------------------------------//

    updateToggleStepContent = () =>{
        //,()=>this.createStepsDisplay()
        this.setState ({
            editingStepAlerts: false,
            toggleAnnotation: false, 
            //editingTime: false
        })

    }

    updateCurrentCameraPlacement =() =>{
    }
// -------------------------------------------------------------- Updates a step's data. --------------------------------------------------------------//

    updateStep = (updatedStep) => {
        let steps = this.state.steps
        updatedStep.content = replaceSpanWithTextInString(updatedStep.content)
        const updatedSteps = steps.map(step => {
                step.content = replaceSpanWithTextInString(step.content)
                if (checkNotUndefindeNull(step.children) && step.children.length > 0) {
                    step.children = step.children.map(kidsteps=>{
                        kidsteps.content = replaceSpanWithTextInString(kidsteps.content)
                        if (kidsteps._id === updatedStep._id) {
                            return updatedStep
                        }
                        else{
                            return kidsteps
                        }   
                    })
                }
            if (step._id === updatedStep._id) {
                return updatedStep
            }
                return step
            }  
        )
        return updatedSteps
    }
// -------------------------------------------------------------- Updates multiple steps. --------------------------------------------------------------//

    updateSteps = async (steps, recentlyAddedStep, withClearData, nodeDeletion, isSubStep, autoEditTitle) => {       
        let path
        let flatSteps = getFlatDataFromTree({
            treeData: this.state.steps,
            getNodeKey: (({ node }) => node._id),
            ignoreCollapsed: false,
        })
        if (withClearData || nodeDeletion) {
            let index = null
            flatSteps.forEach(({node}, i) => {
                if (node._id === this.state.selectedStep._id) {
                    index = i
                }
            })
            let previousStep = index >= 1 ? flatSteps[index - 1] : ""
            let nextStep = index >= 0 ? flatSteps[index + 1] : ""
            let node = previousStep || nextStep
            path = node.path ? node.path : flatSteps[index].path
            let selectedStep = node.node
            
            return this.setState({ steps, path, isSavable: true, selectedStep })
        }
        if (recentlyAddedStep) {
            let r_steps = []
            if (!this.state.isPDFViewer)
            {r_steps = recentlyAddedStep.attachments}
            //if(autoEditTitle ){this.setState({editingStepTitle: true})} 
            // await this.promisedSetState(steps,true,recentlyAddedStep,r_steps)
            // return 
            return this.setState({ steps,  isSavable: true, selectedStep: recentlyAddedStep, currentAttachments:r_steps  }, () => {
                if(autoEditTitle ){this.setState({editingStepTitle: true})} 
            })
        } 
        return this.setState({ steps, isSavable: true })
    }

    //promisedSetState = (steps,isSavable, selectedStep,currentAttachments) => new Promise(resolve => this.setState({steps,isSavable, selectedStep,currentAttachments}, resolve));
// -------------------------------------------------------------- Sets the selected step. --------------------------------------------------------------//

    setSelectedStep=(stepID)=>{
        if (this.state.selectedStepDivID != stepID){
        }
                      
    }
// -------------------------------------------------------------- Updates the Unity context and model loading status. --------------------------------------------------------------//

    updateUnityContext =(context,modelsLoaded) =>{
        if(null != context){
        }

        this.setState({unityContextRef: context, modelsLoaded})
    }
// -------------------------------------------------------------- Updates the tree data. --------------------------------------------------------------//

    updateTree = (steps, addedNode, withClearData) => {
        this.updateSteps(steps, addedNode ? addedNode : this.state.selectedStep, withClearData)
    }
// -------------------------------------------------------------- Updates the editor reference. --------------------------------------------------------------//

    updateEditorRef=(editorRef)=>{
        this.setState({editorRef})
    }
// -------------------------------------------------------------- Checks if an annotation is active. --------------------------------------------------------------//

    checkIfAnnotationIsActive = (divID) => {
        if((this.state.selectedStepDivID).toString().trim() === (divID).toString().trim() ){
           return true;
        }
        return false;
    }
// -------------------------------------------------------------- Generates a random ID. --------------------------------------------------------------//

    makeid = (length)=> {
        var result = '';
        var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()_+';
        var charactersLength = characters.length;
        for ( var i = 0; i < length; i++ ) {
          result += characters.charAt(Math.floor(Math.random() * 
     charactersLength));
       }
       return result;
    }

// -------------------------------------------------------------- Selects a step when a step div is clicked. --------------------------------------------------------------//

    stepDivSelectStep=(e,step,path,randString)=>{
        if("div_step_" + step._id != this.state.selectedStepDivID){
           this.selectStep(step,[path],true)

        }else{
            e.stopPropagation();
            if(typeof e.target.click !== "undefined")
                e.target.click();
        }
        
    }
// -------------------------------------------------------------- Shows an annotation. --------------------------------------------------------------//

    showAnnotation=(event)=>{
        event.stopPropagation()
        let index = event.target.id.split("~~~")[1]
        let annotationID = event.target.id.split("~~~")[0]
        if (this.state.selectedStepDivID !== event.srcElement.offsetParent.parentElement.parentElement.id){
            event.srcElement.offsetParent.parentElement.parentElement.click();
            let id = ""
            this.setState({attachmentIndex:index},()=>{
                
                this.sendAnnotationToWebgl(annotationID)
            })


            }
            else if(this.state.attachmentIndex !== index){
                this.setState({attachmentIndex:index},()=>{
                
                    this.sendAnnotationToWebgl(annotationID)
                })
            }
            else{
                this.sendAnnotationToWebgl(annotationID)
            }

            
        
    }
// -------------------------------------------------------------- Opens WI link in new tab. --------------------------------------------------------------//

    showWI=(event)=>{
        event.stopPropagation()
        this.props.addTab(event.target.innerText, event.target.id)  
    }
// -------------------------------------------------------------- delete wi link. --------------------------------------------------------------//

    deleteWI=(event)=>{
        event.stopPropagation()
        this.deleteWILink({wiID:event.target.id.split("_")[1]})
        
    }
// -------------------------------------------------------------- delete ma link. --------------------------------------------------------------//

    deleteMA=(event)=>{
            event.stopPropagation()
            this.deleteAnnotationCloseImg(event.target.id.split("_")[1].split("~~~")[0],event.target.id.split("~~~")[1])
            
    }
// -------------------------------------------------------------- Gets the path for a given randString. --------------------------------------------------------------//

    getPath=(randString)=>{
        let link = this.state.pathLink.filter(l => l.id == randString)
        return link.path
    }

    setStepDivEventListener=(e)=>{

    }
// -------------------------------------------------------------- Toggles the step dropdown. --------------------------------------------------------------//

    toggleStepDropDown=()=>{
        this.setState(({ toggleStepDropDown }) => ({ toggleStepDropDown: !toggleStepDropDown }));
    }

    renderAttachmentLibraryIcon = (attachments) => {
        let length = attachments.length
        this.toggleAttachments()
        let attachmentsList = attachments.map(attachment => {
            return <li key={`${attachment._id}`}>{attachment.path}</li>
        })
        let tooltipText = length ? <ul>
            <p className="underline">Current Attachments</p>
            {attachmentsList}
        </ul>
         : "Open Attachment Library"
        return addAttachmentIcon(length, this.state.toggleAttachments, tooltipText, false, this.state.displayAttachments) 
    }
// -------------------------------------------------------------- Submits an edited step name. --------------------------------------------------------------//

    submitStepNameEdit = (e, stepName) => {
        e.preventDefault()
        let updatedStep = this.state.selectedStep
        updatedStep.title = stepName
        let steps = this.updateStep(updatedStep)
        this.updateSteps(steps, updatedStep)
        this.setState({ editingStepTitle: false },()=>this.createStepsDisplay())
    }
// -------------------------------------------------------------- Updates the step name during creation. --------------------------------------------------------------//

    updateStepNameOnCreation=(step,stepName)=>{
        let updatedStep = step
        updatedStep.title = stepName
        let steps = this.updateStep(updatedStep)
        this.updateSteps(steps, updatedStep)
       // this.setState({ editingStepTitle: false },()=>this.createStepsDisplay())
    }
// -------------------------------------------------------------- Toggles the editing state for step titles. --------------------------------------------------------------//

    toggleEditingStepTitle=()=>{
        let editTitle = this.state.editingStepTitle
        this.setState({ editingStepTitle: !editTitle },()=> this.createStepsDisplay());
    }
// -------------------------------------------------------------- Determines if an attachment is a 3D model. --------------------------------------------------------------//

    isAttachmentModel=(step,index)=>{
        let attachments = step ? step.attachments: this.state.selectedStep.attachments   
        const currentAttachment = attachments[index]       
        const filename = this.state.viewingAttachment || currentAttachment ? currentAttachment.path : ""  
        if(typeof filename == "undefined" || filename == null){
            return false;
        }    
        let ext = findExtension(filename);
        let typeModel = isModel(ext)  
        return typeModel
    }
// -------------------------------------------------------------- Closes the content editor and resets related states. --------------------------------------------------------------//

    closeOutContentEditor=(clickedToggle)=>{
        if(clickedToggle){
            this.setState({
                AnnotationMode : "view" , 
                textSelectedInEditorFlag:false, 
                textSelectedInEditor:"",
                annotationHasBeenCreatedPre:false,
                addedAnnotation:false,
                },() => console.dir(this.state))
        }
        else{
            this.setState({
                AnnotationMode : "view" , 
                textSelectedInEditorFlag:false, 
                textSelectedInEditor:"",
                annotationHasBeenCreatedPre:false,
                addedAnnotation:false,
                editingStepTitle: false,
                editingStepAlerts: false,
                toggleAnnotation:false,
                editingContent:false},() => this.createStepsDisplay()) 
        }

    }
// -------------------------------------------------------------- Toggles the content form. --------------------------------------------------------------//
    
    toggleContentForm = (e) => {
        e.stopPropagation()
        if (e.target.localName === "button") { return this.openEmbeddedAttachment(e) }
        let toggleContent = this.state.editingContent;
        this.setState({ editingContent: !toggleContent , editingStepTitle: false,
            editingStepAlerts: false,toggleAnnotation:false},() => {this.createStepsDisplay()})
    }
// -------------------------------------------------------------- Checks if path links exist for a step. --------------------------------------------------------------//

    checkPathListExist=(step,step_id,pathLinks)=>{
        let item = {
            id:step_id,
            path:[step._id]
        }

        for(const link of pathLinks)
        {
            if (link.id === item.id){
                return true
            }
                
        }
        return false
    }
// -------------------------------------------------------------- Creates a path link for a step. --------------------------------------------------------------//

    createPathLink=(step,randString)=>{

        let item = {
            id:randString,
            path:[step._id]
        }
        
        return item
        //this.displayArray.push(item)
        // this.setState({pathList:item})
    }
// -------------------------------------------------------------- Gets the current attachment index. --------------------------------------------------------------//

    getAttachmentIndex =()=>{
        return this.state.attachmentIndex
    }
// -------------------------------------------------------------- Checks if an annotation has been created previously. --------------------------------------------------------------//

    getAnnotationHasBeenCreatedPre = () =>{
        return this.state.annotationHasBeenCreatedPre
    }
// -------------------------------------------------------------- Gets the selected annotation. --------------------------------------------------------------//

    getSelectedAnnotation = () => {
        return this.state.selectedAnnotation
    }
// -------------------------------------------------------------- Gets the text selected in the editor. --------------------------------------------------------------//

    getTextSelectedInEditor =() =>{
        return this.state.textSelectedInEditor
    }
// -------------------------------------------------------------- Checks if an annotation has been added. --------------------------------------------------------------//

    getAddedAnnotation=()=>{
        return this.state.addedAnnotation
    }

    getCurrentStepAttachmentModel=()=>{
        return this.state.currentStepAttachmentModel
    }
// -------------------------------------------------------------- THIS CREATES THE DIV THAT RENDERS ALL STEPS --------------------------------------------------------------//
    createStepDiv = (step,stepNum,pathLinks) =>{
       if(this.checkPathListExist(step,step._id,pathLinks)){
           return null;
       } 
        let randString = this.makeid(15)
         let divID = "div_step_" + step._id

        pathLinks.push(this.createPathLink(step,step._id))
        let title = ""
        if(step.title && step.title.length > 0) {
            title = step.title 
        }
        else {
           title = 'Step Title'
           this.updateStepNameOnCreation(step,title)
        } 

        this.setState(prevState => {
            if (!prevState.combinedTitle.some(item => item.split(' - ')[0] === `${stepNum}`)) {
                return { combinedTitle: [...prevState.combinedTitle, `${stepNum} - ${title}`] };
            }
            return null; // No state change needed
        });

        return <li><div className={`step-display-div shadow  ${this.state.selectedStepDivID == divID  ? "selected-step-border" :""}`} id={divID} onClick={(e)=>this.stepDivSelectStep(e,step,step._id,randString)}  key ={`${randString}`} >
           <div className={`step-display-div-header ${this.state.selectedStepDivID == divID ? "selected-step-header-highlight" :""}`}>  

                   {/* PUT STEP # HERE */}
                <h3 style={{marginLeft:"10px"}}>{stepNum}</h3>
                {this.state.editingStepTitle && this.state.selectedStepDivID == divID ? 
                 <EditStepNameFieldContainer 
                      stepTitle={this.state.selectedStep.title && this.state.selectedStep.title.length > 0 ? this.state.selectedStep.title : 'Step Title'}
                     submitStepNameEdit={this.submitStepNameEdit}
                     cancel={()=>this.setState({ editingStepTitle: false},()=>this.createStepsDisplay())}
                 /> :<h3 style={{marginLeft:"10px",width:"calc(100% - 124px)"}} onClick={this.toggleEditingStepTitle}>
                     <LightTooltip title={title} aria-label={title} placement="top" enterDelay={500} enterNextDelay={500}>
                        <div style={{width:"calc(100% - 124px)!important", overflow:"hidden",textOverflow:"ellipsis"}}>
                            {this.highlighter(title.toString())}
                        </div>
                     </LightTooltip>
              </h3>}
              
               {this.state.selectedStepDivID == divID && !this.state.editingStepTitle?  <div style={{width:"124px", display:"flex", flexDirection:"row", marginRight:"10px"}}>
                   <div className="stepButton" id="add-step-content-button" onClick={(e)=>this.toggleContentForm(e)} style={{textAlign:"center",height:"21px", width:"13px", marginTop:"auto", marginBottom:"auto", background:"transparent"}}>
                       <LightTooltip title="Edit Content" aria-label="Edit Content" placement="top" enterDelay={500} enterNextDelay={500}>
                       <FontAwesomeIcon icon={faPenToSquare}/>
                        </LightTooltip>
                   </div>
                   <div  className="stepButton" style={{height:"30px", width:"30px", background:"transparent", marginTop:"auto",marginBottom:"auto"}}>
                       {addAttachmentIcon(1, this.toggleAttachments, "Open Attachment Library", false, true)}
                    </div>
                   <div className="stepButton"  style={{height:"30px", width:"30px", background:"transparent", marginTop:"auto",marginBottom:"auto"}}>
                       {countStepAlerts(1, this.updateEditingStepAlerts, true,false)}
                    </div>
               </div>: null}
            </div>  
            <div className="step-display-div-body">
            {this.state.editingStepAlerts && this.state.selectedStepDivID == divID ?
            <StepAlerts 
                infoPage={this.state.infoPage} 
                selectedStep={this.state.selectedStep ? this.state.selectedStep : undefined}
                updateInfoPage={this.updateInfoPage}
                getInfoPage={this.getInfoPage}
            />          
            :<StepContent                
                addWILink={this.addWILink}
                annotationHasBeenCreatedPre={this.state.annotationHasBeenCreatedPre}
                attachments={this.state.selectedStep ? this.state.selectedStep.attachments : []}
                attachmentIndex={this.state.attachmentIndex}
                clickOnAnnotation={this.clickOnAnnotation}
                closeOutContentEditor={this.closeOutContentEditor}
                currentCameraPlacement={this.state.currentCameraPlacement}
                currentStepAttachmentModel={this.state.currentStepAttachmentModel}
                deleteWILink={this.deleteWILink}
                divStepParent={divID}
                editingContent={this.state.editingContent}
                editingStepTitle={this.state.editingStepTitle}
                editStepTitle={() => this.setState({ editingStepTitle: true })}
                finishEditing={() => this.setState({ editingContent: false })}
                finishStepTitleEdit={() => this.setState({ editingStepTitle: false, editingContent: true })}
                getAddedAnnotation={this.getAddedAnnotation}
                getAttachmentIndex={this.getAttachmentIndex}
                getAnnotationHasBeenCreatedPre={this.getAnnotationHasBeenCreatedPre}
                getCurrentStepAttachmentModel={this.getCurrentStepAttachmentModel}
                getSelectedAnnotation={this.getSelectedAnnotation}
                getTextSelectedInEditor={this.getTextSelectedInEditor}
                highlighter ={this.highlighter}
                modelsLoaded={this.state.modelsLoaded}
                removeAnnotationFromScreen={this.removeAnnotationFromScreen}
                saveNewAnnotation={this.saveNewAnnotation}
                selectedAnnotation={this.state.selectedAnnotation}
                selectedStep={step}
                selectedStepDivID={this.state.selectedStepDivID}
                selectedStepIsChild = {this.state.selectedStepIsChild}                              
                stepSearch = {this.state.searchString}
                textSelectedInEditor={this.state.textSelectedInEditor}
                textSelectionRange={this.state.textSelectionRange}
                toggleAnnotation={this.state.toggleAnnotation}
                toggleContentForm={this.toggleContentForm}                             
                toggleTextSelectedInEditor={this.toggleTextSelectedInEditor}             
                unityContextRef = {this.state.unityContextRef}  
                updateEditorRef={this.updateEditorRef} 
                updateStep={this.updateStep}
                updateSteps={this.updateSteps}
                updateSelectedStep={this.updateSelectedStep}

            /> }
            </div>      
        </div></li>
    }
// -------------------------------------------------------------- Analyzes a step and its child steps, creating a display of the steps. --------------------------------------------------------------//

    analyzeStep = (step,stepNum,pathLinks) =>{
       let displayCreated = [];
        let singleStep = null;
        
        singleStep = this.createStepDiv(step,stepNum,pathLinks)
        if(singleStep != null)
         displayCreated.push(singleStep)

        singleStep = null;

        if (checkNotUndefindeNull(step.children) && step.children.length > 0){
            let kidStepNum = 0;
            for(let i = 0;i < step.children.length;i++){
                let kidStep = step.children[i]
                kidStepNum = kidStepNum + 1
                if (checkNotUndefindeNull(kidStep.children) && kidStep.children.length > 0){
                   let rusStep =  this.analyzeStep(kidStep,`${stepNum}.${kidStepNum}`,pathLinks)
                   displayCreated = [...displayCreated,...rusStep]
                }
                singleStep = this.createStepDiv(kidStep,`${stepNum}.${kidStepNum}` ,pathLinks)
                if(singleStep != null)
                     displayCreated.push(singleStep)

                 singleStep = null;
            }
        }

        return displayCreated
    }
// -------------------------------------------------------------- Creates a display of steps for rendering. --------------------------------------------------------------//

    createStepsDisplay = () =>{   
        let display = []
        let pathLinks = [];
        let stepNum = 0;       
        let first = ""   
        this.state.steps.forEach(step=>{
            stepNum = stepNum + 1
            if (stepNum == 1){first = "div_step_" + step._id}
            let stepsReturned = this.analyzeStep(step,stepNum,pathLinks);
            display = display.concat(stepsReturned)

        })
      
         let selectedContainer = document.getElementsByClassName("selected-container")
         if(selectedContainer.length > 0 && !this.state.firstLoaded){
             selectedContainer[0].click()
         }      
        
        this.setState({stepsDisplay:display,firstLoaded:true})
         
        return <div style={{width:'100%', height:"100%", overflowY:"hidden", overflowX:"hidden"}}>
                    {this.renderStepSearchAndTOCToggle()}
                    <div id="step-Div-Parent" style={{width:'100%', height:"calc(100% - 50px)", overflowY:"scroll", overflowX:"hidden"}}  >
                         <ul>{display}</ul> 
                    </div>               
               </div>
    }
// -------------------------------------------------------------- Sets the selected text and related data for highlighting in the PDF. --------------------------------------------------------------//

    setSelectedText=(selectedText,quads,pageNumber)=>{
        this.setState({selectedText,quads,pageNumber})
    }
// -------------------------------------------------------------- Toggles the visibility of the Table of Contents (TOC). --------------------------------------------------------------//

    toggleTOC = () =>{
        this.setState(({ showTOC }) => ({ showTOC: !showTOC }));
    }
// -------------------------------------------------------------- Toggles the annotation panel. --------------------------------------------------------------//

    toggleAnnotation =(e)=>{
        e.stopPropagation();
        let toggleAnnotation = this.state.toggleAnnotation
        this.setState ({toggleAnnotation: !toggleAnnotation, editingStepAlerts:false,editingContent:false},() => this.createStepsDisplay());
    }
// -------------------------------------------------------------- Changes the first step div to the selected step. --------------------------------------------------------------//

    clickFirstStepDiv=(display)=>{
        let id = display[0].props.children.props.id
        let el = document.getElementById(id)
        if(checkNotUndefindeNull(el)){
            el.click();
        }
    }
// -------------------------------------------------------------- Opens wi link modal selection. --------------------------------------------------------------//

    setWILinkModal=(modalState)=>{
        this.setState({addingPDFPageWILink:modalState})
    }
// -------------------------------------------------------------- Handles changes in the search input for step divs. --------------------------------------------------------------//

    stepDivSearchChange =(e) =>{
        this.setState({ searchString: e.target.value })
        let parentDiv = document.getElementById("step-Div-Parent");
    }
// -------------------------------------------------------------- Highlights text based on a search string. --------------------------------------------------------------//

    highlighter= (text)=>{
        return    <Highlighter
                    highlightClassName="YourHighlightClass"
                    searchWords={[this.state.searchString]}
                    autoEscape={true}
                    className="highlightDivFont noWrapTitle"
                    textToHighlight={text}
                />
    }

    renderStepSearchAndTOCToggle = () =>{
      return  <div style={{height:"50px", width:"100%", display:"flex", flexDirection:"row" }}>
            <div style={{width:"calc(100% - 100px)"}}>
                <input 
                style={{marginTop:"12px", marginLeft:"12px",width:"95%"}} 
                type="text" 
                placeholder='Search' 
                id={`stepDivSearch_${this.props.wip_ID}`}
                onChange={e => this.stepDivSearchChange(e)}
                value={this.state.searchString}
                />

            </div>
            <div style={{width:"100px"}}>
                {tocToggleIcon(this.toggleTOC,true,false)}           
            </div>
        </div>

        
    }
// -------------------------------------------------------------- Sets the attachment index and checks if the attachment is a model. --------------------------------------------------------------//

    setAttachmentIndex=(value)=>{
        let isModel = this.isAttachmentModel(null,value);
        this.setState({attachmentIndex: value, currentStepAttachmentModel: isModel},()=>this.createAnnotationArray())
    }
// -------------------------------------------------------------- Sets the PDF viewer instance. --------------------------------------------------------------//

    setPdfViewerInstance =(instance,docViewer, PDFAnnotations,annoManager)=>{
        this.setState({instance,docViewer, PDFAnnotations,annoManager},()=>{this.getSetWipPDF()})
    }
// -------------------------------------------------------------- Retrieves and sets the Work in Progress (WIP) PDF. --------------------------------------------------------------//

    getSetWipPDF = async () =>{
        if(checkNotUndefindeNull(this.state.instance) && checkNotUndefindeNull(this.state.steps)) {
          await  axios.get(
                fileUrl(fileKey(this.state.workInstruction.steps[0].attachments[0])),
                { responseType: "arraybuffer" }
              ).then(rep=>{
                    var file = new Blob([rep.data], { type: "application/pdf" });
                    var fileURL = URL.createObjectURL(file);
                    this.setState({
                        currentPDF: file,
                    });
                    this.state.instance.UI.loadDocument(fileURL,{fileName: fileName(this.state.workInstruction.preview_img || '') })
              });
        }
    }
// -------------------------------------------------------------- Sets the mapping annotations in the state. --------------------------------------------------------------//

    setMappingAnnotations=(annoList)=>{
        this.setState({annoList})
    }
// -------------------------------------------------------------- Retrieves camera information from the Unity context. --------------------------------------------------------------//

    getCameraInfo=()=>{
        if(checkNotUndefindeNull(this.state.unityContextRef)){
         this.state.unityContextRef.send("Manager","OutputCameraPositionData")
        }
    }
// -------------------------------------------------------------- Deletes a single PDF annotation. --------------------------------------------------------------//

    deleteSingleAnnotation=(wi)=>{
        this.deletePDFAnnotation(String(this.state.selectedAnnotation.elementName))
        if(wi){
            this.deleteWILink({wiID:wi})
        }
    }
// -------------------------------------------------------------- Adds a new highlight annotation to the PDF. --------------------------------------------------------------//

    addNewHighlightAnnotation=()=>{
        const highlight = new this.state.PDFAnnotations.TextHighlightAnnotation();
        let id = this.makeid(15);
        highlight.PageNumber = this.state.pageNumber;
        highlight.X = 405;
        highlight.Y = 165;
        highlight.Width = 275;
        highlight.Height = 25;    
        highlight.StrokeColor = new this.state.PDFAnnotations.Color(255, 255, 0);
        highlight.Quads = this.state.quads
        highlight.elementName = String(highlight.Id)
        this.state.annoManager.addAnnotation(highlight);
        this.state.annoManager.drawAnnotations(highlight.PageNumber);
        let annoListClone = Array.isArray(this.state.annoList) ? [...this.state.annoList] : [];
        let item = {
            Anno_id : String(highlight.Id),
            highlight_color: "225,225,0",
            text: this.state.selectedText,
            str : this.convertQuads(), 
            quads: this.state.quads,
            pageNumber:this.state.pageNumber,
            mappingID:"", 
            pdf: this.state.pdfPath, 
            attachments: [],
            WIPID: this.state.workInstruction._id
        }
        createHighlight(item).then((data)=>{
            item._id = data.data._id;
            annoListClone.push(item)
            this.setState({annoList:annoListClone,
                currentlySelectedPDFAnnotationAttachment: item.attachments,
                currentlySelectedPDFAnnotationID: item.quads[0],
                currentAttachments: item.attachments,
                currentHighlightID: data.data._id,
                attachmentIndex: 0,
                isRedraw:false
            },()=>{this.toggleAttachments()})
        }).catch((error)=>{
            console.log(error);
        })
    }  
// -------------------------------------------------------------- Adds a new highlight wi link to the PDF. --------------------------------------------------------------//

    addNewWILinkAnnotation=(wip_ID)=>{
        const highlight = new this.state.PDFAnnotations.TextHighlightAnnotation();
        let id = this.makeid(15);
        highlight.PageNumber = this.state.pageNumber;
        highlight.X = 405;
        highlight.Y = 165;
        highlight.Width = 275;
        highlight.Height = 25;    
        highlight.StrokeColor = new this.state.PDFAnnotations.Color(144,238,144);
        highlight.Quads = this.state.quads
        highlight.elementName = String(highlight.Id) + "~~~~WILINK:" + JSON.stringify(wip_ID);
        this.state.annoManager.addAnnotation(highlight);
        this.state.annoManager.drawAnnotations(highlight.PageNumber);
        let annoListClone = this.state.annoList
        let item = {
            Anno_id : String(highlight.Id) + "~~~~WILINK:" + JSON.stringify(wip_ID),
            highlight_color: "144,238,144",
            text: this.state.selectedText,
            str : this.convertQuads(), 
            quads: this.state.quads,
            pageNumber:this.state.pageNumber,
            mappingID:"", 
            pdf: this.state.pdfPath, 
            attachments: [],
        }
        annoListClone.push(item)
        let title = this.state.selectedText
        this.setState({annoList:annoListClone,
            currentlySelectedPDFAnnotationAttachment: item.attachments,
            currentlySelectedPDFAnnotationID: item.quads[0],
            currentAttachments: item.attachments,
            attachmentIndex: 0,
            isRedraw:false
        },()=>{    
            this.addWILink(wip_ID)
        })
    } 
// -------------------------------------------------------------- Converts quads to a string format. --------------------------------------------------------------//

    convertQuads=()=>{
        return `${this.state.quads[0].x1},${this.state.quads[0].x2},${this.state.quads[0].x3},${this.state.quads[0].x3},
        ${this.state.quads[0].y1},${this.state.quads[0].y2},${this.state.quads[0].y3},${this.state.quads[0].y3}`
    }
// -------------------------------------------------------------- Checks if an annotation is to be redrawn. --------------------------------------------------------------//

    returnIsRedraw = (g)=> {
        return this.state.isRedraw;
    }
// -------------------------------------------------------------- Deletes a PDF annotation and updates the annotation list. --------------------------------------------------------------//

    deletePDFAnnotation=(id)=>{
        let annotations = this.state.annoList.filter(anno => id != anno.Anno_id )
        let annoToDelete = this.state.annoList.filter(anno => id == anno.Anno_id )
        deleteHighlight(annoToDelete).then((data)=>{
            this.setState({annoList:annotations},() => {this.saveWorkInstruction();this.redrawAnnotations()  })
        }).catch((error)=>{
            console.log(error)
            alert("There was an error deleteing the annotation.")
        })
    }
// -------------------------------------------------------------- Redraws PDF highlights and sets the selected annotation. --------------------------------------------------------------//

    redrawAnnotations=()=>{
        const annots = this.state.annoManager.getAnnotationsList();
        this.state.annoManager.deleteAnnotations(annots);
        let data = this.state.annoList
          if (data != null && data.length > 0){
             data.forEach(anno => {
               const highlight = new this.state.PDFAnnotations.TextHighlightAnnotation();
               highlight.PageNumber = anno.pageNumber;                
               highlight.StrokeColor = new this.state.PDFAnnotations.Color(255, 255, 0);
               highlight.Quads = anno.quads
               highlight.elementName = anno.Anno_id
               this.state.annoManager.addAnnotation(highlight);
               this.state.annoManager.drawAnnotations(highlight.PageNumber);
             });
          
          }
    }
// -------------------------------------------------------------- Sets the "isRedraw" state to true. --------------------------------------------------------------//

    setIsRedrawTrue=(annotation,quads)=>{
        this.setState({isRedraw:true},()=>this.setSelectedAnnotationPDF(annotation,quads))
    }
// -------------------------------------------------------------- Sets the selected PDF annotation and related data. --------------------------------------------------------------//

    setSelectedAnnotationPDF=(annotation,quads)=>{
        const annots = this.state.annoManager.getAnnotationsList();
          this.state.annoManager.deleteAnnotations(annots);
            this.state.annoList.forEach(anno=>{
                if (this.isHighlightTheSame(quads,anno.quads[0])){
                    this.redrawHighlights(true,anno)
                    this.setState({
                        selectedAnnotation:annotation,
                        currentlySelectedPDFAnnotationAttachment: anno.attachments,
                        currentlySelectedPDFAnnotationID: anno.quads[0],
                        currentAttachments: anno.attachments,
                        attachmentIndex: 0,
                        isRedraw:false

                    })
                }
                else{
                    this.redrawHighlights(false,anno)
                }
            })
    }
// -------------------------------------------------------------- Redraws PDF highlights, marking the selected annotation as selected. --------------------------------------------------------------//

    redrawHighlights =(isSelected,anno)=>{
        const highlight = new this.state.PDFAnnotations.TextHighlightAnnotation();
        highlight.PageNumber = anno.pageNumber;  
        if(isSelected){
          highlight.StrokeColor = new this.state.PDFAnnotations.Color(173,216,230);
        }else{
          highlight.StrokeColor = new this.state.PDFAnnotations.Color(255, 255, 0);  
        }                      
        highlight.Quads = anno.quads
        highlight.elementName = anno.Anno_id
        this.state.annoManager.addAnnotation(highlight);
        this.state.annoManager.drawAnnotations(highlight.PageNumber);
    }
// -------------------------------------------------------------- Updates the annotation list in the state. --------------------------------------------------------------//

    updateAnnoList=(list)=>{
      this.setState({annoList:list})
    }

    render = () => {     
        let attachments = this.state.currentAttachments
        if(this.state.isPDFViewer === 0){
            attachments = []
        }
        return <div >
            {this.renderModal()}
             <div id="success-banner" className="flex-centered fade-in-and-out max-width"
                style={{ display: `${this.state.confirmationMessage.length > 0 ? "flex" : "none"}` }}
                onClick={this.closeConfirmation}>
                <p>{this.state.confirmationMessage}</p>
            </div> 
            <div  className="flex">
                <div id="LeftRightAuthorContainer">
                    <div id="wi-author-right" className="flex-row max-size">
                        <div id="attachments-display-container" className="flex-column max-width">
                            {attachments.length > 0 ?
                                <AttachmentRenderer
                                    attachments={this.state.currentAttachments}
                                    setAttachmentIndex={(value) => this.setAttachmentIndex(value)}
                                    attachmentIndex={this.state.attachmentIndex}
                                    updateColor={this.storeColor}
                                    WIPID = {this.state.workInstruction._id}
                                    storeCameraData={this.storeCameraData}
                                    openAttachments={() => this.setState({ showingAttachments: true })}
                                    updateCurrentCameraPlacement = {this.updateCurrentCameraPlacement}
                                    toggleAnnotation={this.state.toggleAnnotation}
                                    unityContextRef = {this.state.unityContextRef}
                                    updateUnityContext = {this.updateUnityContext}
                                    callFromAuthor = {true}
                                    textSelectedInEditorFlag={this.state.textSelectedInEditorFlag}
                                    textSelectedInEditor={this.state.textSelectedInEditor}
                                    isPDFViewer={this.state.isPDFViewer}
                                    currentlySelectedPDFAnnotationID={this.state.currentlySelectedPDFAnnotationID}
                                    libraryOpen={this.state.showingAttachments}
                                    />
                                :
                                <Directions openAttachments={this.props.openAttachments} />}
                        </div>
                        <div >
                        
                        </div>
                    </div>
                     <div id="wi-author-left" className="flex max-height"> 
                     {this.state.isPDFViewer?
                     <div style={{width:"100%",overflow:"hidden" }}>                    
                         <Toolbar
                                        WITitle={this.state.title}
                                        toggleEditTags={this.toggleEditTags}
                                        isPDFWip={true}
                                        currentWorkInstructionTags={cloneDeep(this.props.workInstruction.tags)}
                                        isSavable={this.state.isSavable}
                                        saveWorkInstruction={this.saveWorkInstruction}
                                        previewWorkInstruction={this.previewWorkInstruction}
                                        editPublicationPage={this.editPublicationPage}
                                        isReleased={this.state.isReleased}
                                        toggleAllAlertsPage={this.toggleAllAlertsPage}
                                        toggleRelease={this.toggleRelease}
                                        togglePublicationPage={this.togglePublicationPage}
                                    />

                        <PDFDisplay
                        setSelectedText={this.setSelectedText}
                        setPdfViewerInstance={this.setPdfViewerInstance}
                        textToSearch={this.state.textToSearch}
                        currentPDF={this.state.currentPDF}
                        setMappingAnnotations={this.setMappingAnnotations}
                        getCameraInfo={this.getCameraInfo}
                        unityContextRef={this.state.unityContextRef}
                        addNewHighlightAnnotation={this.addNewHighlightAnnotation} 
                        PDFViewerHighlights={this.state.PDFViewerHighlights}
                        deletePDFAnnotation={this.deletePDFAnnotation}
                        toggleAttachments = {this.toggleAttachments}
                        setSelectedAnnotation={this.setIsRedrawTrue}
                        updateAnnoList={this.updateAnnoList}
                        isRedraw={this.returnIsRedraw}
                        deleteSingleAnnotation={this.deleteSingleAnnotation}
                        setWILinkModal={this.setWILinkModal}
                        openNewTab={this.props.addTab}
                        /> 
                       
                     </div>
                                          
                     :
                      <Fragment> <div id={`${this.state.showTOC? 'steps-display-container-half':'steps-display-container-full'}`}>
                          <div style={{width:'100%', height:"100%", overflowY:"hidden", overflowX:"hidden"}}>
                            {this.renderStepSearchAndTOCToggle()}

{/* ---------------------------------------------------------------- DISPLAYS STEPS AND EDITOR  (LEFT SIDE) ---------------------------------------------------------------- */}

                            <div id="step-Div-Parent" style={{width:'100%', height:"calc(100% - 50px)", overflowY:"scroll", overflowX:"hidden"}}  >
                                <ul>{this.state.stepsDisplay}</ul>
                            </div>
                        </div>
                        </div>
{/* ---------------------------------------------------------------- DISPLAYS STEP TREE (RIGHT SIDE) ---------------------------------------------------------------- */}

                        {this.state.loaded && this.state.showTOC ?
                            <TableOfContents
                                getSteps={()=> {return this.state.steps}}
                                getPath={()=>{return this.state.path}}
                                WIPID={this.props.wip_ID}
                                steps={this.state.steps}
                                stepDeleted={this.stepDeleted}
                                selectStep={this.selectStep}
                                editTitle={() => this.setState({ editingStepTitle: true })}
                                toggleAllAlertsPage={this.toggleAllAlertsPage}
                                selectedStepId={this.state.selectedStep ? this.state.selectedStep._id : 0}
                                tree={this.state.tree}
                                path={this.state.path}
                                selectedStep={this.state.selectedStep}
                                addStep={this.addStep}
                                updateTree={this.updateTree}
                                updateSteps={this.updateSteps}
                                UpdateStepNodePath={(list) => this.setState({stepNodePath: list})}
                                combinedTitle={this.state.combinedTitle}
                                toolbar={
                                    <Toolbar
                                        WITitle={this.state.title}
                                        toggleEditTags={this.toggleEditTags}
                                        // toggleAutoSave={this.toggleAutoSave}
                                        // hasAutoSave={this.state.hasAutoSave}
                                        isPDFWip={false}
                                        currentWorkInstructionTags={cloneDeep(this.props.workInstruction.tags)}
                                        // submitTitleEdit={(title) => this.setState({ title, isSavable: true })}
                                        isSavable={this.state.isSavable}
                                        saveWorkInstruction={this.saveWorkInstruction}
                                        previewWorkInstruction={this.previewWorkInstruction}
                                        editPublicationPage={this.editPublicationPage}
                                        isReleased={this.state.isReleased}
                                        toggleAllAlertsPage={this.toggleAllAlertsPage}
                                        toggleRelease={this.toggleRelease}
                                        togglePublicationPage={this.togglePublicationPage}
                                    />}
                            /> 
                            :null
                        } 
                       </Fragment> } 
                    </div>
                    
                </div>
            </div>
        </div>
    }
}

export default withRouter(WIAuthor)